export enum SponsorRoleLabels {
  Investor,
  'Owner occupier',
}
